<template>
  <b-modal ref="modal" hide-footer centered title="Create View">
    <b-form @submit.prevent="save">
      <b-form-group label="View title:">
        <b-form-input
          type="text"
          v-model.trim="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          autocomplete="off"
          :disabled="inProcess"
        />
        <b-form-invalid-feedback v-if="!$v.title.required">View title is required</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.title.notDefault">View title "{{ title }}" key reserved by system</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.alphaNum"
        >
          View title accepts only alphanumerics
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button variant="success" type="submit" :disabled="inProcess">Save</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators'
const alphaNum = helpers.regex('alphaNum', /^[A-Za-z][A-Za-z0-9_-\s]*$/)
// services
import db from '@/services/db'

export default {
  name: 'dataGrid_createViewModal',
  props: ['inherited'],
  data() {
    return {
      inProcess: false,
      gridId: null,
      widgetKey: null,
      title: null,
    }
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()

      const dataGridInst = this.$instByClass(this, 'data-grid')

      this.gridId = dataGridInst.gridId
      this.widgetKey = dataGridInst.widgetKey
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      if (this.inPorcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inPorcess = true

      this.$nextTick(() => {
        this.$v.$reset()
      })

      const data = {
        gridId: this.gridId,
        widgetKey: this.widgetKey,
        title: this.title,
        inherited: this.inherited,
      }

      db.dataGrid.options.createView(data).then(() => {
        this.gridId = null
        this.widgetKey = null
        this.title = null
        this.close()
      })
    },
  },
  validations: {
    title: {
      required,
      notDefault () {
        if (!this.title) return true
        if (this.title.toLowerCase() === 'default') return false
        return true
      },
      alphaNum
    }
  },
}
</script>
